// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_INFINITE_RECLINE = "nekone\u010dno";
